var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3336",
    "data-name": "Rectangle 3336",
    width: 15,
    height: 15,
    transform: "translate(405 357)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-405 -357)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M3.961.519A.934.934,0,0,1,4.8,0H8.326a.934.934,0,0,1,.838.519l.211.419h2.812a.938.938,0,1,1,0,1.875H.938a.938.938,0,0,1,0-1.875H3.75ZM.938,3.75h11.25v9.375A1.877,1.877,0,0,1,10.313,15h-7.5A1.877,1.877,0,0,1,.938,13.125ZM3.75,5.625a.47.47,0,0,0-.469.469v6.562a.469.469,0,1,0,.938,0V6.094A.47.47,0,0,0,3.75,5.625Zm2.813,0a.47.47,0,0,0-.469.469v6.562a.469.469,0,1,0,.938,0V6.094A.47.47,0,0,0,6.563,5.625Zm2.812,0a.47.47,0,0,0-.469.469v6.562a.469.469,0,1,0,.938,0V6.094A.47.47,0,0,0,9.375,5.625Z",
    transform: "translate(405.938 357)",
    fill: "#ff4b4b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeleteIcon);
export default __webpack_public_path__ + "static/media/menu-delete-icon.dd35b7684845f6f9853cb476e57ca33e.svg";
export { ForwardRef as ReactComponent };